module.exports = __webpack_public_path__ + "../resources/img/new_tooltip.0689d1bf.png";